/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Payment_Failed_TooltipInputs */



/**
* | output |
* | --- |
* | "Update payment method to manage add-ons" |
*
* @param {Sub_Addons_Payment_Failed_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_payment_failed_tooltip = /** @type {((inputs?: Sub_Addons_Payment_Failed_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Payment_Failed_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlungsmethode aktualisieren, um Add-ons zu verwalten")
	return /** @type {LocalizedString} */ ("Update payment method to manage add-ons")
});